module.exports = __webpack_public_path__ + "fonts/fa-regular-400.49d7fd7.woff2";